export const GET_TICKETS = 'GET_TICKETS';
export const GET_PLACE_ID = 'GET_PLACE_ID';
export const GET_BALANCE_PLACE = 'GET_BALANCE_PLACE';
export const GET_EXTRACTS_PLACES = 'GET_EXTRACTS_PLACES';
export const GET_PLACE_FARE = 'GET_PLACE_FARE';
